import { useTranslation } from 'react-i18next'

import { Alert, Button } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const HiddenBlockNotice = ({ onOpenPreviewSettings }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Alert type="warning">{t('Este bloque está oculto en la configuración actual de la preview.')}</Alert>
      <Button variant="outlined" fullWidth onClick={onOpenPreviewSettings}>
        {t('Ir a la configuración de la preview')}
      </Button>
    </Styles.Container>
  )
}

export default HiddenBlockNotice
